/**
 * Created by Abner Sui on 01/22/2019.
 * Description:
 *
 * ------ maintenance history ------
 */

import { Subject } from 'rxjs';

export class BlastEmailDetailConfig {
    keywordStoreSelector?: any;
    messageStoreSelector: any; // useless now\
    prefix: string; // smart reducer action prefix name
    instanceId: string; // smart reducer action prefix value
    singlePageMode: boolean; // identify whether this component is used inside Research View or Blast Email View; There is no highlight and maximize feature in Blast Email View;
    actions$: Subject<any>;
    events$: Subject<any>;

    constructor() {
        this.actions$ = new Subject<any>();
        this.events$ = new Subject<any>();
        this.singlePageMode = false;
    }
}

export enum BlastEmailDetailActions {
    TOGGLE_MAXIMIZE = 'TOGGLE_MAXIMIZE',
    CLEAR = 'CLEAR'
}
